import React from "react";
import ReactApexChart from "react-apexcharts";
import { BRAND } from "../utils/brand";

const ProfitLossChart = () => {
    const chartOptions = {
        chart: {
            type: "bar",
            height: 350,
            toolbar: { show: false },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "55%",
                borderRadius: 5,
            },
        },
        dataLabels: {
            enabled: false,
        },
        colors: [BRAND.teal],
        xaxis: {
            categories: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
            ],
        },
        legend: {
            position: "top",
            horizontalAlign: "center",
        },
        fill: {
            opacity: 0.9,
        },
        title: {
            text: "Profit/Loss",
            align: "left",
            style: {
                fontSize: "18px",
                fontWeight: 600,
            },
        },
    };

    const chartSeries = [
        {
            name: "Sales Analytics",
            data: [65, 58, 80, 45, 55, 78, 50],
        },
    ];

    return (
        <div className="chart-container">
            <ReactApexChart
                options={chartOptions}
                series={chartSeries}
                type="bar"
                height={360}
            />
        </div>
    );
};

export default ProfitLossChart;
